import { useContext } from 'react';
import { ModalContext, ModalContextInterface } from '@/contexts/modal/modal-context';

export default function useModal() {
  const { setModal, getModal, deleteModal, modals } = useContext<ModalContextInterface>(ModalContext);

  return {
    setModal,
    getModal,
    deleteModal,
    modals,
  };
}
